import { action, computed, makeObservable, observable } from 'mobx';
import UtilsService from '../services/UtilsService';
import toolbarService from '../services/ToolbarService';
import { ActivityStatus } from '../../Constants';

export class StudentActivityManager {
  @observable
  activityId = null;

  @observable
  activityInstanceStatus = ActivityStatus.ACTIVITY_LOCKED;

  @observable
  lastContentItemPresented = null;

  @observable
  lastContentItemViewed = null;

  @observable
  isAssignmentReadOnly = false;

  @observable
  showCorrectAnswers = true;

  @observable
  isSubmitted = false;

  @observable studentName = '';

  @observable studentId = null;

  /** One entry per activity instance; same student id may appear more than once. */
  @observable scoringInstances = [];

  @observable currentInstanceIndex = 0;

  @observable studentInstruction = null;

  // @observable
  activityNoteText = null;

  constructor() {
    makeObservable(this);
  }

  @action setStudentActivity = (studentActivity, activityId) => {
    this.studentActivity = studentActivity;

    this.activityId = activityId;

    this.activityInstanceStatus = studentActivity.activityInstanceStatus;

    this.lastContentItemPresented = studentActivity.lastContentItemPresented;

    this.lastContentItemViewed = studentActivity.lastContentItemViewed;

    this.isAssignmentReadOnly = studentActivity.isAssignmentReadOnly;

    this.showCorrectAnswers = studentActivity.showCorrectAnswers;

    this.isSubmitted = studentActivity.submitted === true;

    this.studentInstruction = studentActivity.instruction;
    toolbarService.setStudentInstructionVisibility(this.hasInstruction);

    this.activityNoteText = studentActivity.noteText;
  }

  @action
  getNextInstance = () => {
    this.currentInstanceIndex += 1;
    if (this.currentInstanceIndex >= this.scoringInstances.length) {
      this.currentInstanceIndex = 0;
    }
    return this.scoringInstances[this.currentInstanceIndex];
  }

  @action
  getPreviousInstance = () => {
    this.currentInstanceIndex -= 1;
    if (this.currentInstanceIndex < 0) {
      this.currentInstanceIndex = (this.scoringInstances.length - 1);
    }
    return this.scoringInstances[this.currentInstanceIndex];
  }

  @action
  setActivityUsers = (users, studentId, preferredActivityId = null) => {
    this.scoringInstances = [];
    let index = 0;
    if (users && users.length > 0) {
      users.forEach((user) => {
        this.scoringInstances.push(user);
      });
      if (!UtilsService.isNullOrEmpty(preferredActivityId)) {
        const activityIndex = users.findIndex((user) => user.activityId === preferredActivityId);
        if (activityIndex >= 0) {
          index = activityIndex;
        } else if (!UtilsService.isNullOrEmpty(studentId)) {
          const studentIndex = users.findIndex((user) => user.id === studentId);
          if (studentIndex >= 0) {
            index = studentIndex;
          }
        }
      } else if (!UtilsService.isNullOrEmpty(studentId)) {
        const studentIndex = users.findIndex((user) => user.id === studentId);
        if (studentIndex >= 0) {
          index = studentIndex;
        }
      }
    }
    this.currentInstanceIndex = index;
  }

  @computed
  get currentInstance() {
    return this.scoringInstances[this.currentInstanceIndex];
  }

  @computed
  get instanceCount() {
    return this.scoringInstances.length;
  }

  @computed
  get uniqueStudentCount() {
    const studentIds = new Set();
    this.scoringInstances.forEach((instance) => {
      if (instance?.id) {
        studentIds.add(instance.id);
      }
    });
    return studentIds.size;
  }

  @action setStudentActivityId = (activityId) => {
    this.activityId = activityId;
  }

  @action setStudentName = (user) => {
    this.studentName = `${user.firstName} ${user.lastName}`;
  }

  @action setStudentId = (id) => {
    this.studentId = id;
  }

  @action setActivityNoteText = (text) => {
    this.activityNoteText = text;
  }

  @computed get studentActivityId() {
    return this.activityId;
  }

  @computed get hasInstruction() {
    let tempInstruction = this.studentActivity.instruction;

    if (tempInstruction === undefined || tempInstruction === null || tempInstruction === '') {
      return false;
    }

    tempInstruction = UtilsService.stripTagsAndEntities(tempInstruction);
    tempInstruction = tempInstruction.trim();

    if (tempInstruction === undefined || tempInstruction === null || tempInstruction === '') {
      return false;
    }

    return true;
  }
}

export default new StudentActivityManager();
